import { h } from 'preact'
import { useState, useEffect, useRef } from 'preact/hooks'
import PropTypes from 'prop-types'

import { usePortal } from 'lib/portal'
import Icon from 'components/Icon'
import './index.sass'

const RING_DURATION = 30000

export default function CallNotificationPopup({
  callerName,
  chatName,
  organizationApikey,
  callType,
  onAccept,
  onDecline,
}) {
  const [timeLeft, setTimeLeft] = useState(Math.floor(RING_DURATION / 1000))
  const intervalRef = useRef(null)

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(intervalRef.current)
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current)
    }
  }, [])

  const iconType = callType === 'video' ? 'video' : 'audio'
  const callLabel = callType === 'video' ? 'Video Call' : 'Audio Call'

  const content = <div className="CallNotificationPopup">
    <div className="CallNotificationPopup-backdrop" onClick={onDecline} />
    <div className="CallNotificationPopup-card">
      <div className="CallNotificationPopup-pulse" />
      <div className="CallNotificationPopup-header">
        <div className="CallNotificationPopup-iconWrap">
          <Icon type={iconType} size="lg" />
        </div>
        <div className="CallNotificationPopup-info">
          <div className="CallNotificationPopup-callerName">
            {callerName}
          </div>
          <div className="CallNotificationPopup-callLabel">
            {callLabel}
          </div>
          <div className="CallNotificationPopup-chatInfo">
            {chatName}
            {organizationApikey && <span className="CallNotificationPopup-orgBadge">
              {organizationApikey}
            </span>}
          </div>
        </div>
      </div>

      <div className="CallNotificationPopup-timer">
        {timeLeft > 0 ? `${timeLeft}s` : 'Ringing...'}
      </div>

      <div className="CallNotificationPopup-actions">
        <button
          className="CallNotificationPopup-btn CallNotificationPopup-btn-decline"
          onClick={onDecline}
          title="Decline"
        >
          <Icon type="close" />
          <span>Decline</span>
        </button>
        <button
          className="CallNotificationPopup-btn CallNotificationPopup-btn-accept"
          onClick={onAccept}
          title="Accept"
        >
          <Icon type={iconType} />
          <span>Accept</span>
        </button>
      </div>
    </div>
  </div>

  return usePortal()(content)
}

CallNotificationPopup.propTypes = {
  callerName: PropTypes.string.isRequired,
  chatName: PropTypes.string,
  organizationApikey: PropTypes.string,
  callType: PropTypes.oneOf(['video', 'audio']).isRequired,
  isGroupCall: PropTypes.bool,
  onAccept: PropTypes.func.isRequired,
  onDecline: PropTypes.func.isRequired,
}
